export const visit = (vm, at) => {
vm(require("timezone-utils/lang/fr-ca.lyaml"));
vm(require("ui-addon-i18n/lang/fr-ca.lyaml"));
vm(require("UIComponents/lang/fr-ca.lyaml"));
vm(require("MeetingsLib/lang/fr-ca.lyaml"));
vm(require("sanitize-text/lang/fr-ca.lyaml"));
vm(require("I18n/lang/fr-ca.lyaml"));
at({ "fr-ca": { "placeholderString": "R\xE9unions" } });
};